import React, { FC, memo } from "react";
import { ResourceTypeLink, ServiceListItemDc } from "@evergis/api";
import { Icon, IconButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { TableAlias, TableNameContainer } from "./styled";

import {
  useCurrentProjectWithAddedLayers,
  useIsLayerInProject,
} from "../../../../hooks/project/useAddLayersToCurrentProject";

import { useResourceType } from "../../../../hooks/useResourceType";

import { CardControlsProps } from "../../types";

// eslint-disable-next-line max-lines-per-function
const TableNameComponent: FC<Omit<CardControlsProps, "config">> = ({ resource }) => {
  const { t } = useTranslation("catalog");
  const { alias } = resource as ServiceListItemDc;
  const [resourceType] = useResourceType();
  const addLayerToCurrentProject = useCurrentProjectWithAddedLayers([resource]);
  const isAddedLayer = useIsLayerInProject(resource.name);

  return (
    <TableNameContainer>
      <TableAlias>{alias}</TableAlias>
      {resourceType === ResourceTypeLink.Layer && isAddedLayer && (
        <Icon style={{ marginLeft: "0.5rem" }} primary={isAddedLayer} kind={"success"} title={t("labelAdded")} />
      )}
      {resourceType === ResourceTypeLink.Layer && !isAddedLayer && (
        <IconButton className="actions" kind={"feature_add"} title={t("add")} onClick={addLayerToCurrentProject} />
      )}
    </TableNameContainer>
  );
};

export const TableName: FC<Omit<CardControlsProps, "config">> = memo(TableNameComponent);
